import WebSocketStore from 'core/classes/services/WebSocketStore'

class OnboardingBPTCReconfirmationApi {
  public async fetch(language: string) {
    const wsClient = WebSocketStore.get('onboarding')

    return wsClient.call<TBPReconfirmationFetchResponse>({
      service: 'bp-reconfirmation',
      action: 'fetch-terms-and-condition',
      payload: {
        language,
      },
      withoutTokenRefresh: true,
      isAuth: true,
      returnError: true,
    })
  }

  public async submit(data: TBPReconfirmationSubmit) {
    const wsClient = WebSocketStore.get('onboarding')

    return wsClient.call({
      service: 'bp-reconfirmation',
      action: 'submit-terms-and-condition',
      payload: data,
      withoutTokenRefresh: true,
      isAuth: true,
      returnError: true,
    })
  }
}

export type TBPReconfirmationRequest = {
  email: string
}

export type TBPReconfirmationSubmit = {
  templateUID: string
} & TFormData

type TFormData = {
  allowEmail: boolean
  allowCall: boolean
  isAgreed: boolean
}

export type TBPTCReconfirmationPartner = {
  partnerId: string
  tradingName: string
  taxId: string
  address: {
    countryName: string
    countryISO: string
    city: string
    address1: string
    zip: string
  }
}

type TBPReconfirmationFetchResponse = {
  languages: { id: string; value: string }[]
  reconfirmation: {
    allowEmail: boolean
    allowCall: boolean
    signDate: Date
  } | null
  partner: TBPTCReconfirmationPartner
  templateUID: string
  attachmentUID: string
  messages?: string[]
}

export const onboardingBPTCReconfirmationApi = new OnboardingBPTCReconfirmationApi()
